<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option
      v-for="item in records?.records"
      :key="item.id"
      :title="item.bizType"
      :value="item.id"
      >{{ item.bizType }}</a-select-option
    >
  </a-select>
</template>

<script lang="ts">
import { WorkOrderService } from "@/views/maintenance/workOrder/workOrder.service";
import { defineComponent, onMounted, watch } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 工单类型
 *
 * 使用方式:
 * <workOrder-select v-model:value="formRef.id"></workOrder-select>
 */
export default defineComponent({
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
    defaultValue: {
      type: String,
      default: undefined,
    },
    status: {
      type: Number,
      default: 1,
    },
    agreementType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = WorkOrderService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };
    onMountedOrActivated(async () => {
      await run({ status: props.status });
      // console.log("🚀 ~ file: index.vue:65 ~ onMounted ~ records:", records);
      if (props.defaultValue) {
        let item = ((records?.value?.records || []) as Array<any>).find(
          (r) => r.bizType == props.defaultValue
        );
        if (item) {
          emit("update:value", item.id);
          emit("change", item.id);
        }
      }
    });
    watch(
      () => props.agreementType,
      (n) => {
        if (n && n == "bx") {
          let item = ((records?.value?.records || []) as Array<any>).find(
            (r) => r.bizType == props.defaultValue
          );
          if (item) {
            emit("update:value", item.id);
            emit("change", item.id);
          }
        }
      }
    );
    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
